<!-- header -->
<ion-header>
    <ion-toolbar>
        <ion-title class="ion-text-capitalize">
            <span>Verify Details</span>
        </ion-title>
        <ion-button slot="end" fill="none" (click)="global.closeModal(false)">
            <ion-icon name="close"></ion-icon>
        </ion-button>
    </ion-toolbar>
</ion-header>
<div class="overflow-y-auto">
    <div class="modal-padding pt-0 grid grid-cols-2 gap-x-6 gap-y-1">
        <app-form-field
            label="Please enter the OTP sent to the phone number ."
            *ngIf="changeType==='phone' || changeType==='both'">
            <mat-form-field>
                <input
                    matInput
                    required
                    type="text"
                    [(ngModel)]="phoneOtp"
                    name="phoneOtp"
                    appNoWhitespace
                    inputmode="numeric"
                    pattern="\d*"
                    maxlength="4"
                    (input)="onPhoneOtpChange($event)" />
                <mat-error appFieldErrors></mat-error>
            </mat-form-field>
        </app-form-field>
        <app-form-field
            label="Please enter the OTP sent to the Email ."
            *ngIf="changeType==='email' || changeType==='both'">
            <mat-form-field>
                <input
                    matInput
                    required
                    type="text"
                    [(ngModel)]="emailOtp"
                    name="emailOtp"
                    appNoWhitespace
                    inputmode="numeric"
                    pattern="\d*"
                    maxlength="4"
                    (input)="onEmailOtpChange($event)" />
                <mat-error appFieldErrors></mat-error>
            </mat-form-field>
        </app-form-field>
    </div>
</div>

<!-- action buttons container -->
<ion-footer>
    <ion-button
        class="btn__primary"
        (click)="onPhoneSubmit()"
        [disabled]="disablePhoneSubmit"
        *ngIf="(changeType==='phone' || changeType==='both') && !phoneVerified"
        >Verify Phone Number</ion-button
    >
    <ion-button
        class="btn__primary"
        (click)="onEmailSubmit()"
        [disabled]="disableEmailSubmit"
        *ngIf="(changeType==='email' || changeType==='both') && !emailVerified"
        >Verify Email</ion-button
    >
</ion-footer>
